import { useSelector, useDispatch } from 'react-redux';
import { useAuthN } from '../authN/useAuthN';
import * as companyActions from '../redux/actions/companyActions.Thunks';

export const useCompanySettingsLogic = () => {
	const company = useSelector((state) => state.company);
	const dispatch = useDispatch();

	const { getAccessToken, isInProgress, isAuthenticated } = useAuthN();

	const updateCompanySettings = async (updatedCompanySettings) => {
		if (isAuthenticated && !isInProgress && company) {
			const atResponse = await getAccessToken(APIS.lp.scopes);
			try {
				await dispatch(
					companyActions.updateCompanySettings(
						atResponse.accessToken,
						company.enterpriseProfileId,
						updatedCompanySettings
					)
				);
				return true;
			} catch {
				return false;
			}
		}
	};

	return {
		updateCompanySettings
	};
};
